import Axios from 'axios'
import tools from '@/api/tools'
import { Loading, Message } from 'element-ui'
import qs from 'qs'

let Flag = true
let Flager = true
Axios.defaults.timeout = 20000
Axios.defaults.headers.common.Authorization = tools.authorization()
Axios.defaults.transformRequest = [
  (data, headers) => {
    const contentType = headers['Content-Type']
    headers.common.Authorization = tools.authorization()
    if (contentType === 'application/x-www-form-urlencoded') {
      return qs.stringify(data)
    }else{
      headers['Content-Type'] = 'application/json'
    }
    return JSON.stringify(data)
  }
]
let needLoadingRequestCount = 0
let loadingInstance

// 显示loading
function startLoading () {
  if (!needLoadingRequestCount) {
    loadingInstance = Loading.service({ })
  }
  needLoadingRequestCount++
}

function endLoading () {
  needLoadingRequestCount--
  if (!needLoadingRequestCount) {
    loadingInstance.close()
  }
}

// 请求拦截器
Axios.interceptors.request.use(config => {
  let hideLoading = false
  if (config.custom) {
    hideLoading = config.custom.hideLoading
  }
  if (!hideLoading) {
    startLoading()
  }
  // 在发送请求之前做些什么
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 响应拦截器
Axios.interceptors.response.use(response => {
  Flag = true
  Flager = true
  let hideLoading = false
  if (response.config.custom) {
    hideLoading = response.config.custom.hideLoading
  }
  if (!hideLoading) {
    endLoading()
  }
  const data = response.data
  let onClose = function () {
    // 默认什么都不操作
  }
  if (data.status === 401) {
    onClose = function () {
      window.location.href = '/web/userCenter/'
    }
  }
  if (data.status < 200 || data.status >= 300) {
    Message({
      message: response.data.message,
      type: 'warning',
      onClose: onClose
    })
  }
  return response
}, error => {
  endLoading()
  let message = '访问不到该地址'
  const response = error.response
  if (response.data && response.data.message) {
    message = response.data.message
  }
  if (Flager) {
    if (response.status === 404) {
      Flager = false
      Message({
        message: message,
        type: 'warning'
      })
    }
  }
  if (Flag) {
    if (response.status === 401) {
      Flag = false
      Message({
        message: message,
        type: 'warning'
      })
      setTimeout(function () {
        window.location.href = '/web/userCenter/'
      }, 3000)
    }
  }
})
